import { render, staticRenderFns } from "./BreadcrumbsSkeleton.vue?vue&type=template&id=a5ec7004&scoped=true"
import script from "./BreadcrumbsSkeleton.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbsSkeleton.vue?vue&type=style&index=0&id=a5ec7004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ec7004",
  null
  
)

export default component.exports